import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Box,
  Container,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Button,
  BottomNavigation,
  BottomNavigationAction,
} from "@mui/material";
import {
  Notifications as NotificationsIcon,
  AccountCircle as AccountCircleIcon,
  Logout as LogoutIcon,
  CalendarToday as CalendarTodayIcon,
  Home as HomeIcon,
  Payment as PaymentIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Profile = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    return (
      <Container>
        <Typography variant="h6" color="error">
          Aucun utilisateur trouvé. Veuillez vous reconnecter.
        </Typography>
      </Container>
    );
  }

  const handleLogout = () => {
    localStorage.removeItem("CC_Token");
    localStorage.removeItem("user");
    toast.success("Vous avez été déconnecté avec succès.", {
      position: "top-right",
      autoClose: 3000,
    });
    setTimeout(() => navigate("/login"), 4000);
  };

  const handleNavigateToNotifications = () => {
    navigate("/AdminGetNotifs");
  };

  const handleProfile = () => {
    navigate("/ProfileAdmin");
  };

  return (
    <div className="app">
      <ToastContainer />
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar alt="Logo" src={"../assets/cej.png"} sx={{ width: 40, height: 40, marginRight: "0.5rem" }} />
          <Typography
            variant="h6"
            sx={{ flexGrow: 1, fontSize: { xs: "1rem", sm: "1.25rem" }, color: "#ffffff" }}
          >
            Club Équestre Jafoura
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <LogoutIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Center the content */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh", // Full screen height
          marginTop: "100px", // Adjust this value if needed
        }}
      >
        <Container maxWidth="sm" sx={{ padding: "1rem" }}>
          <Card sx={{ padding: "1rem", boxShadow: 3, borderRadius: "12px" }}>
            <CardContent>
              <Box display="flex" justifyContent="center" mb={2}>
                <Avatar sx={{ width: 80, height: 80, backgroundColor: "#003366" }}>
                  <AccountCircleIcon sx={{ fontSize: 60, color: "white" }} />
                </Avatar>
              </Box>
              <Typography variant="h5" align="center" sx={{ fontWeight: "bold", color: "#003366" }}>
                {user.name}
              </Typography>
              <Typography variant="subtitle1" align="center" sx={{ color: "#666" }}>
                {user.role.toUpperCase()}
              </Typography>
              <List>
                <ListItem>
                  <ListItemText primary="Email" secondary={user.email} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Statut" secondary={user.isActive ? "Actif" : "Inactif"} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Créé le" secondary={new Date(user.created_at).toLocaleDateString()} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Dernière mise à jour" secondary={new Date(user.updated_at).toLocaleDateString()} />
                </ListItem>
              </List>
              <Button
                variant="contained"
                fullWidth
                sx={{ backgroundColor: "#003366", color: "white", fontWeight: "bold", mt: 2 }}
                onClick={handleLogout}
              >
                Déconnexion
              </Button>
            </CardContent>
          </Card>
        </Container>
      </Box>

      {/* Bottom Navigation */}
     <Box sx={{ position: "fixed", bottom: 0, width: "100%" }}>
             <BottomNavigation
               sx={{
                 backgroundColor: "#003366",
                 display: "flex",
                 justifyContent: "space-between",
                 alignItems: "center",
               }}
             >
               <BottomNavigationAction
                 label="Calendrier"
                 icon={<CalendarTodayIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
                 sx={{ color: "#ffffff", minWidth: "auto" }}
                 onClick={() => navigate("/AdminChrono")}
               />
               <BottomNavigationAction
                 label="Home"
                 icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
                 sx={{ color: "#ffffff", minWidth: "auto" }}
                 onClick={() => navigate("/Admin")}
               />
               <BottomNavigationAction
                 label="Paiement"
                 icon={<PaymentIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
                 sx={{ color: "#ffffff", minWidth: "auto" }}
                 onClick={() => navigate("/AdminPaiment")}
               />
             </BottomNavigation>
           </Box>
    </div>
  );
};

export default Profile;
